var map = {
	"./Vector.png": "a35f",
	"./bitcoin.png": "0641",
	"./btc.png": "c6d6",
	"./businesses/btc.png": "2574",
	"./businesses/eth.png": "87c6",
	"./businesses/eur.png": "9061",
	"./businesses/gbp.png": "d569",
	"./businesses/usd.png": "9b01",
	"./businesses/usdc.png": "d907",
	"./businesses/usdt.png": "8e81",
	"./eth.png": "88f6",
	"./ether.png": "914d",
	"./logo3.png": "bdf3",
	"./nopayments.png": "5e2e",
	"./success_tick.png": "a76b",
	"./try.png": "a213",
	"./usd.png": "8e88",
	"./usdc.png": "6f85",
	"./usdt.png": "728d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";